import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiContracts = () => {
 const { auth } = contextApp();

 const ContractApi = axios.create({
  baseURL: urls.contract(),
  headers: { 'x-access-token': auth?.token }
 });

 /*  const createOrUpdateSetting = async newSetting => (await SettingApi.post(`/${company}`, newSetting)).data;
 const getSetting = async (query = null) => (await SettingApi.get(`/${company}`, { params: query })).data; */

 /* 
 const getPersonByDoc = async ({ docType, docNumber }) => (await ContractApi.get(`/${docType}/${docNumber}`)).data;

 const createPerson = async newPerson => (await ContractApi.post('/', newPerson)).data;

 const createCustomer = async newCustomer => (await ContractApi.post('/customer', newCustomer)).data;
 */
 const getContracts = async () => (await ContractApi.get('/')).data;

 const newContract = async newContract => (await ContractApi.post('/', newContract)).data;

 return { newContract, getContracts };
};

export default { useApiContracts };
